import { render, staticRenderFns } from "./jinqihuodong.vue?vue&type=template&id=4027f80c&scoped=true"
import script from "./jinqihuodong.vue?vue&type=script&lang=js"
export * from "./jinqihuodong.vue?vue&type=script&lang=js"
import style0 from "./jinqihuodong.vue?vue&type=style&index=0&id=4027f80c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4027f80c",
  null
  
)

export default component.exports